import IconArrow from '@/components/assets/icon_arrow_down.svg'
import { cn } from '@/lib/utils'

import { useTranslations } from 'next-intl'

interface ShowReplyToggleProps {
  toggleReplies: () => void
  showReplies: boolean
  replyCount: number
}

export const ShowReplyToggle = ({
  toggleReplies,
  showReplies,
  replyCount,
}: ShowReplyToggleProps) => {
  const t = useTranslations()
  return (
    <div
      className="group flex cursor-pointer items-center gap-1 px-2 py-1.5"
      onClick={toggleReplies}
    >
      <IconArrow
        className={cn(
          '[&>path]:fill-vive-brand-50 group-hover:[&>path]:fill-vive-brand-40 200',
          showReplies && 'rotate-x-180',
        )}
      />
      <p className="body-2-omni-styles text-vive-brand-50 group-hover:text-vive-brand-40">
        {`${replyCount} ${t('comment-thread.replies')}`}
      </p>
    </div>
  )
}

export const ShowMoreReplies = ({ loadMore }: { loadMore: () => void }) => {
  const t = useTranslations()

  return (
    <div
      className="group mt-2 ml-10.5 flex cursor-pointer items-center gap-1 px-2 py-1 md:ml-16"
      onClick={loadMore}
    >
      <IconArrow className="[&>path]:fill-vive-brand-50 group-hover:[&>path]:fill-vive-brand-40 200" />
      <p className="body-2-omni-styles text-vive-brand-50 group-hover:text-vive-brand-40">
        {t('comment-reply.more-replies')}
      </p>
    </div>
  )
}
